import { useDispatch, useSelector } from 'react-redux';

import {
    analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickDone,
    analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickTryAgain,
} from '@perpay-web/fintech/actions/analytics/cardOnboardingMVP2';
import CardApplicationUnfreeze from '@perpay-web/fintech/components/composite/CardApplicationUnfreeze/CardApplicationUnfreeze';
import {
    creditUnfreezeForCardAccountApplicationDataModule,
    getIsLoading,
    getIsClarityFrozen,
} from '@perpay-web/fintech/dataModules/creditUnfreezeCardAccountApplication';
import { getPartnerHostedApplicationUUID } from '@perpay-web/fintech/dataModules/partnerHostedCardApplication';
import { paths } from '@perpay-web/fintech/props/appPaths';

const PartnerOnboardingCardApplicationUnfreezeContainer = () => {
    const dispatch = useDispatch();

    const cardAccountApplicationUuid = useSelector(
        getPartnerHostedApplicationUUID,
    );
    const isLoading = useSelector(getIsLoading);
    const isClarityFrozen = useSelector(getIsClarityFrozen);

    const onClickDone = () =>
        dispatch(analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickDone());

    const onClickTryAgain = () => {
        // Reset any previous error state before making new request
        dispatch(creditUnfreezeForCardAccountApplicationDataModule.dataReset());

        dispatch(
            creditUnfreezeForCardAccountApplicationDataModule.dataRequest(
                cardAccountApplicationUuid,
            ),
        );
        dispatch(
            analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickTryAgain(),
        );
    };

    return (
        <CardApplicationUnfreeze
            onClickDone={onClickDone}
            onClickTryAgain={onClickTryAgain}
            dashboardURL={`${paths.dashboard.path}?PHO_complete=true`}
            isLoading={isLoading}
            showRetryMessage={isClarityFrozen}
        />
    );
};

export default PartnerOnboardingCardApplicationUnfreezeContainer;
